class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );

    this.buyNowButtonWrapper = this.querySelector('.shopify-payment-button');

    this.currencySymbol = this.dataset.currencySymbol || '$';

    this.isPreorder = this.dataset.preorder === 'true';

    const hiddenInput = this.querySelector('#preorder-date');
    this.preorderDate =
      hiddenInput?.value ||
      this.querySelector('[data-preorder-date]')?.dataset?.preorderDate ||
      null;

    // Page load default price
    window.addEventListener('DOMContentLoaded', () => {
      this.setInitialPrice();
    });

    // On page load, use current variant to set button text.
    // NOTE: never read this.form.id directly — an <input name="id"> that is a
    // named control of the form (inside it, or associated via form="") shadows
    // the form's `id` property and returns the element, not the string. Use
    // getAttribute('id'), which is not shadowed. For multi-variant products the
    // id input lives outside the <form> (in <product-selector>) and is linked
    // via the form attribute, so fall back to a form-association lookup.
    window.addEventListener('DOMContentLoaded', () => {
      const formId = this.form?.getAttribute('id');
      const variantIdInput =
        this.form?.querySelector('[name="id"]') ||
        (formId && document.querySelector(`[name="id"][form="${formId}"]`));
      if (variantIdInput && variantIdInput.value) {
        this.updateButtonText(variantIdInput.value);
      } else {
        this.setInitialPrice();
      }
    });

    // When variant changes, update
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id') {
        this.updateButtonText(e.target.value);
      }
    });

    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  // Calculate and show estimated delivery
  updateEstimatedDelivery(days) {
    const deliveryEl = document.getElementById('estimated-delivery');
    if (!deliveryEl) return;

    if (!days || isNaN(days)) {
      deliveryEl.textContent = '';
      deliveryEl.classList.remove('date-visible');
      return;
    }

    const today = new Date();
    today.setDate(today.getDate() + parseInt(days, 10));
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    deliveryEl.textContent = `Estimated Delivery Date: ${today.toLocaleDateString(
      undefined,
      options
    )}`;

    deliveryEl.classList.add('date-visible');
  }

  setInitialPrice() {
    const variantIdInput = this.form?.querySelector('[name="id"]');

    if (variantIdInput && variantIdInput.value) {
      this.updateButtonText(variantIdInput.value);
    } else {
      const productPrice = this.dataset.productPrice;
      if (productPrice) {
        const rawPrice = productPrice / 100;
        const priceFormatted = `${this.currencySymbol}${
          Number.isInteger(rawPrice) ? rawPrice : rawPrice.toFixed(2)
        }`;

        // This was commented out in your theme, leaving as is
        // this.submitButton.textContent = this.isPreorder
        //   ? `Pre-Order Now for ${priceFormatted}`
        //   : `Add to Cart - ${priceFormatted}`;

        if (!this.isPreorder) {
          const deliveryDays =
            document.getElementById('estimated-delivery')?.dataset.days;
          if (deliveryDays) {
            this.updateEstimatedDelivery(deliveryDays);
          }
        }
      }
    }
  }

  updateButtonText(variantId) {
    if (!variantId) return;

    // Track the latest requested variant. Rapid variant swaps fire overlapping
    // fetches that can resolve out of order; a stale response for a previous
    // variant must not overwrite the button (causes a price flicker).
    this.latestVariantRequest = variantId;

    fetch(`/variants/${variantId}.js`)
      .then((res) => res.json())
      .then((variant) => {
        if (!variant) return;
        if (String(this.latestVariantRequest) !== String(variantId)) return;

        const rawPrice = variant.price / 100;
        const priceFormatted = `${this.currencySymbol}${
          Number.isInteger(rawPrice) ? rawPrice : rawPrice.toFixed(2)
        }`;

        let opt1;
        let opt2;
        if (variant.option1) {
          opt1 = variant.option1;
        }
        if (variant.option2) {
          opt2 = variant.option2;
        }

        let selec = document.querySelector('.product-item.currently-viewing');
        if (selec) {
          let inner = selec.querySelector('.product-selector__label');
          if (inner) {
            let first = inner.querySelector('p:first-child');
            let last = inner.querySelector('p:nth-child(2)');
            if (first) {
              let span = first.querySelector('span');
              if (span && opt1) {
                span.textContent = opt1.split('-')[0].trim();
              }
            }

            if (last) {
              let span = last.querySelector('span');
              if (span && opt2) {
                span.textContent = opt2.split('-')[0].trim();
              }
            }
          }
        }

        if (variant.available) {
          // Re-enable the add button (it may have been disabled by a previously
          // selected sold-out variant).
          if (this.submitButton) this.submitButton.removeAttribute('disabled');
          this.productBar
            ?.querySelector('[name="add"]')
            ?.removeAttribute('disabled');
          let vars = document.querySelectorAll('.all_vars li');
          vars.forEach((vart) => {
            let id = vart.dataset.varid;
            if (String(variant.id) === String(id)) {
              // preOrderFunctionalityForMainAndRecommended
              const currently_viewing_selected_option = document.querySelector(
                `.currently-viewing .custom-variant-type.custom-image-new option[value="${variant.id}"]`
              );
              if (currently_viewing_selected_option) {
                const currentlyViewing = document.querySelector(
                  '.currently-viewing'
                );
                if (currentlyViewing) {
                  currentlyViewing.dataset.preorderFromDate =
                    currently_viewing_selected_option.dataset.preorderFromDate;
                  currentlyViewing.dataset.preorderToDate =
                    currently_viewing_selected_option.dataset.preorderToDate;
                }
              }
              if (
                typeof window.preOrderFunctionalityForMainAndRecommended ===
                'function'
              ) {
                window.preOrderFunctionalityForMainAndRecommended();
              }
              // preOrderFunctionalityForMainAndRecommended

              // New metafields code START
              let preorderFromDate = vart.dataset.preorderFromDate;
              let preorderToDate = vart.dataset.preorderToDate;
              if (preorderFromDate && preorderToDate) {
                const preorderTextEl = document.querySelector(
                  '.preorder-notice__text'
                );
                if (preorderTextEl) {
                  preorderTextEl.innerHTML = `Estimated shipping window between <strong>${window.formatDate(
                    preorderFromDate
                  )}</strong> and <strong>${window.formatDate(
                    preorderToDate
                  )}</strong>`;
                  preorderTextEl.dataset.preorderFromDate = preorderFromDate;
                  preorderTextEl.dataset.preorderToDate = preorderToDate;
                }

                let cboxes =
                  document.querySelectorAll('.related-product-checkbox:checked');
                let numChecked = cboxes.length;
                if (numChecked === 0) {
                  let cusBtn = document.querySelector('.add-cart-custom.button');
                  if (cusBtn) {
                    cusBtn.textContent = 'ADD 1 ITEM FOR PRE-ORDER';
                  }
                }

                const shopPayButton = document.querySelector(
                  '.shopify-payment-button'
                );
                const estimatedDelivery = document.getElementById(
                  'estimated-delivery'
                );
                const preorderNotice = document.querySelector(
                  '.b.product__preorder-notice.preorder'
                );

                if (shopPayButton) shopPayButton.style.display = 'none';
                if (estimatedDelivery) estimatedDelivery.style.display = 'none';
                if (preorderNotice) preorderNotice.style.display = 'block';

                if (this.submitButton) {
                  this.submitButton.textContent = `Pre-Order Now for ${priceFormatted}`;
                }
                if (estimatedDelivery) {
                  estimatedDelivery.textContent = '';
                }
              } else {
                let cboxes =
                  document.querySelectorAll('.related-product-checkbox:checked');
                let numChecked = cboxes.length;
                if (numChecked === 0) {
                  let cusBtn = document.querySelector('.add-cart-custom.button');
                  if (cusBtn) {
                    cusBtn.textContent = 'ADD 1 ITEM TO CART';
                  }
                }

                const shopPayButton = document.querySelector(
                  '.shopify-payment-button'
                );
                const estimatedDelivery = document.getElementById(
                  'estimated-delivery'
                );
                const preorderNotice = document.querySelector(
                  '.b.product__preorder-notice.preorder'
                );

                if (shopPayButton) shopPayButton.style.display = 'block';
                if (estimatedDelivery) estimatedDelivery.style.display = 'block';
                if (preorderNotice) preorderNotice.style.display = 'none';

                if (this.submitButton) {
                  this.submitButton.textContent = `Add to Cart - ${priceFormatted}`;
                }
                const deliveryDays = estimatedDelivery?.dataset.days;
                if (deliveryDays) {
                  this.updateEstimatedDelivery(deliveryDays);
                }
              }
              // New metafields code END
            }
          });
        } else {
          if (this.submitButton) {
            this.submitButton.textContent = 'Sold Out';
            // Disable so a sold-out variant can't be added to cart.
            this.submitButton.setAttribute('disabled', 'disabled');
          }
          this.productBar
            ?.querySelector('[name="add"]')
            ?.setAttribute('disabled', 'disabled');
          // Hide preorder notice if variant is sold out
          const preorderNotice = document.querySelector(
            '.b.product__preorder-notice.preorder'
          );
          if (preorderNotice) preorderNotice.style.display = 'none';
          this.hideBuyNow();
          const estimatedDelivery = document.getElementById(
            'estimated-delivery'
          );
          if (estimatedDelivery) {
            estimatedDelivery.textContent = '';
          }
        }
      })
      .catch(() => {});
  }

  // Hide the dynamic-checkout ("Buy with Shop") button on sold-out variants.
  // The in-stock branch above re-shows it via display='block', so switching
  // back to a purchasable variant restores it.
  hideBuyNow() {
    const shopPayButton = document.querySelector('.shopify-payment-button');
    if (shopPayButton) shopPayButton.style.display = 'none';
  }

  // Submit handler - now purely metafield based
  async onSubmitHandler(event) {
    event.preventDefault();

    const submitter = event.submitter || this.submitButton;
    submitter?.classList.add('disabled');

    if (!this.form.checkValidity()) {
      submitter?.classList.remove('disabled');
      return;
    }

    // Pre-order ETA cart attribute is written by the single consolidated sync in
    // global.js (reads live variant metafields). The duplicate writer that used to
    // live here (and the post-add "clear ETA" block below) were removed so there is
    // exactly one writer.

    // Step 2: Add the item to cart via AJAX
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    formData.append(
      'sections',
      this.cartDrawer
        ?.getSectionsToRender()
        .map((section) => section.section)
    );
    formData.append('sections_url', window.location.pathname);

    // Detect pre-order based on metafields on .all_vars li for the current variant
    const variantIdFromForm = formData.get('id');

    if (variantIdFromForm) {
      const variantMetaNode = document.querySelector(
        `.all_vars li[data-varid="${variantIdFromForm}"]`
      );
      if (variantMetaNode) {
        const preorderFrom = variantMetaNode.dataset.preorderFromDate;
        const preorderTo = variantMetaNode.dataset.preorderToDate;
        // Single shared stamp (window.SelahPreorder) — byte-identical label across surfaces.
        const preorderProps = window.SelahPreorder.properties(preorderFrom, preorderTo);
        Object.keys(preorderProps).forEach((key) =>
          formData.append(`properties[${key}]`, preorderProps[key])
        );
      }
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        // Update side cart
        this.cartDrawer?.renderContents(response);

        // (Removed the post-add "clear Pre-order ETA" block — global.js's single
        // sync recomputes and clears the attribute when no pre-order remains.)
      })
      .catch(() => {})
      .finally(() => {
        submitter?.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }

  toggleAddButton(disable, text, preorder) {
    [
      this.submitButton,
      this.productBar?.querySelector('[name="add"]')
    ].forEach((submitButton) => {
      if (disable) {
        submitButton?.setAttribute('disabled', 'disabled');
        if (text && submitButton) submitButton.textContent = text;
      } else if (submitButton && !preorder) {
        submitButton.removeAttribute('disabled');
        submitButton.textContent = this.hasAttribute('data-has-selling-plan')
          ? window.variantStrings.addSubscriptionToCart
          : window.variantStrings.addToCart;
      } else if (preorder) {
        submitButton.removeAttribute('disabled');
        submitButton.textContent = this.hasAttribute('data-has-selling-plan')
          ? window.variantStrings.addSubscriptionToCart
          : window.oakreativStrings.preorder;
      }
    });
  }
}

customElements.define('product-form', ProductForm);